import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const HYDRATION_ROUTINES: Partial<Routine>[] = [
  {
    id: "daily-hydration-schedule",
    title: "Daily Hydration Schedule",
    symbol: "💧",
    description: "Ensure consistent water intake throughout your day",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[3].value,
    steps: [
      {
        id: "hydration-daily-1",
        title: "Morning glass",
        description: "Drink 16oz of water right after waking up",
      },
      {
        id: "hydration-daily-2",
        title: "Hourly reminder",
        description: "Drink 8oz of water every 2-3 hours throughout the day",
      },
      {
        id: "hydration-daily-3",
        title: "Evening hydration",
        description: "Have a final glass of water 1-2 hours before bed",
      },
    ],
  },
  {
    id: "hydration-variety-mix",
    title: "Hydration Variety Mix",
    symbol: "💧",
    description: "Make staying hydrated more enjoyable with flavor variations",
    dailyRoutine: false,
    selectedDays: [{ day: "sunday", datetime: "10:00:00.000Z" }],
    color: RoutineColors[4].value,
    steps: [
      {
        id: "hydration-variety-1",
        title: "Prepare infusions",
        description: "Create fruit, herb, or vegetable infused water combinations",
      },
      {
        id: "hydration-variety-2",
        title: "Make herbal teas",
        description: "Brew caffeine-free herbal teas to enjoy hot or cold",
      },
      {
        id: "hydration-variety-3",
        title: "Store properly",
        description: "Fill reusable bottles for easy access throughout the week",
      },
    ],
  },
  {
    id: "activity-hydration-plan",
    title: "Activity Hydration Plan",
    symbol: "💧",
    description: "Optimize hydration before, during, and after exercise",
    dailyRoutine: false,
    selectedDays: [
      { day: "monday", datetime: "16:00:00.000Z" },
      { day: "wednesday", datetime: "16:00:00.000Z" },
      { day: "friday", datetime: "16:00:00.000Z" },
    ],
    color: RoutineColors[5].value,
    steps: [
      {
        id: "hydration-activity-1",
        title: "Pre-workout hydration",
        description: "Drink 16oz of water 1-2 hours before exercising",
      },
      {
        id: "hydration-activity-2",
        title: "During-activity sips",
        description: "Take small, frequent sips every 15-20 minutes during exercise",
      },
      {
        id: "hydration-activity-3",
        title: "Post-workout replenishment",
        description: "Drink 16-24oz of water or electrolyte drink after finishing",
      },
    ],
  },
];
